import { Reveal, ScrollMaskLine } from "./Reveal";

const CHAPTERS = [
  {
    n: "Ch. 01",
    title: "About CMD+DesignLab",
    body: "A studio for the bold. We partner with businesses, organizations and events to shape visual solutions that carry strategy, personality and craft in equal measure.",
  },
  {
    n: "Ch. 02",
    title: "Behind the Mark",
    body: "Our name is our method: CMD — command intent, and the + — the creative addition that makes work unmistakably yours. Every mark starts with meaning.",
  },
  {
    n: "Ch. 03",
    title: "Creative Process",
    body: "Discover, define, design, deliver. A disciplined process with room for happy accidents — because the best ideas rarely arrive in a straight line.",
  },
];

const LAB_IMG =
  "https://images.unsplash.com/photo-1753505889211-9cfbac527474?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMGRlc2lnbiUyMHN0dWRpbyUyMGludGVyaW9yfGVufDB8fHx8MTc4NDE0MjQ4OXww&ixlib=rb-4.1.0&q=85";

export default function InsideLab() {
  return (
    <section
      id="inside-the-lab"
      data-testid="inside-lab-section"
      className="relative py-28 md:py-40 bg-[#090514]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="mb-16 flex items-center gap-3">
          <span className="h-px w-10 bg-[#C77DFF]" />
          <span className="text-xs uppercase tracking-[0.35em] text-[#C77DFF]">
            Inside the Lab
          </span>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Sticky spotlight image */}
          <div className="lg:col-span-5">
            <Reveal className="lg:sticky lg:top-28">
              <div className="clip-frame relative aspect-[4/5]">
                <img
                  src={LAB_IMG}
                  alt="Inside CMD+DesignLab creative studio"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#090514] via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6">
                  <div className="font-display font-extrabold text-white text-3xl">
                    The Lab
                  </div>
                  <div className="text-[#E0B0FF] text-sm">
                    Where marks are made
                  </div>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Manifesto chapters */}
          <div className="lg:col-span-7">
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] mb-14">
              <ScrollMaskLine>Design with</ScrollMaskLine>
              <ScrollMaskLine delay={0.1} className="text-[#C77DFF]">
                purpose.
              </ScrollMaskLine>
            </h2>

            <div className="space-y-2">
              {CHAPTERS.map((c, i) => (
                <Reveal
                  key={c.n}
                  delay={i * 0.1}
                  className="grid md:grid-cols-12 gap-4 md:gap-8 border-t border-[#2D1B4E] py-8"
                  data-testid={`chapter-${i}`}
                >
                  <div className="md:col-span-3">
                    <span className="font-display text-sm uppercase tracking-widest text-[#6d5b95]">
                      {c.n}
                    </span>
                  </div>
                  <div className="md:col-span-9">
                    <h3 className="font-display font-bold text-2xl md:text-3xl text-white mb-3">
                      {c.title}
                    </h3>
                    <p className="text-[#B5A6CC] leading-relaxed max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
